import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import TabsPageLayout from 'src/components/TabsPageLayout';
import { PORTAL_ROUTE } from 'src/constants/routes';
import { Box } from '@mui/material';
import { Loader } from 'src/components';
import { WDAC_CATALOG_INVENTORY_PREVIOUS_PATH, wdacCatalogInventoryTabs } from '../constants';
import useGetCatalogInventoryDetails from '../../../../../queries/catalogInvectoryDetails/useGetCatalogInventoryDetails';
import useGetCatalogInventoryTabCounts from '../../../../../queries/catalogInvectoryDetails/useGetCatalogInventoryTabCounts';

const CatalogInventoryTabs = () => {
  const { catalogInventoryId } = useParams();

  const { isLoading: catalogInventoryIsLoading, data } = useGetCatalogInventoryDetails({ catalogInventoryId });

  const { data: tabCountsData, isLoading: countsIsLoading } = useGetCatalogInventoryTabCounts({
    catalogInventoryId,
  });

  const backNavigationPath = useMemo(() => {
    const storedPath = sessionStorage.getItem(WDAC_CATALOG_INVENTORY_PREVIOUS_PATH);
    return storedPath || `${PORTAL_ROUTE}/wdac-results/catalog-inventory`;
  }, []);

  if (catalogInventoryIsLoading) {
    return <Loader />;
  }

  return (
    <div>
      <TabsPageLayout
        hasBackButton
        title={
          <>
            <Box display="flex" alignItems="center" gap={1}>
              {data?.globalCatalog.applicationName || 'No Display Name'}
            </Box>
          </>
        }
        tabs={wdacCatalogInventoryTabs(
          catalogInventoryId,
          tabCountsData?.totalAffectedCount,
          tabCountsData?.totalAlteredCount,
          countsIsLoading,
        )}
        backNavigationPath={backNavigationPath}
        wrapperProps={{
          sx: {
            maxWidth: '100%',
          },
        }}
        titleProps={{
          fontSize: '1.4rem',
        }}
      />
    </div>
  );
};

export default CatalogInventoryTabs;
